import { JsonSchema } from "@jsonforms/core";

export const justReturnControl = (
  readonly: boolean | undefined,
  hidden: boolean | undefined,
  isCheckResults: boolean | undefined,
  isOptional: boolean
) => readonly || hidden || !isCheckResults || !isOptional;

export const getFieldName = (path: string | undefined) =>
  path?.split(".").pop();

export const schemaIsOptional = (
  schema: JsonSchema,
  fieldName: string | undefined
) => {
  if (fieldName && Array.isArray(schema.required)) {
    return !schema.required.includes(fieldName);
  }
  return false;
};

export const copyValuesWithoutKeyAtPath = (
  values: any,
  path: string | undefined
) => {
  const newValue = { ...values };
  const keys = path?.split(".") ?? [];
  const parentValue = keys.reduce((acc, key, index) => {
    if (acc && typeof acc === "object" && index < keys.length - 1) {
      return acc[key];
    }
    return acc;
  }, newValue);
  const fieldName = getFieldName(path);
  if (parentValue && fieldName) {
    delete parentValue[fieldName];
    return newValue;
  }
};
